// api/Stations

import request from '@utils/request'

const url = 'api/Stations/'

/**
 *
 * 注册终端用户
 * @export
 * @param {*} data
 * @return {*}
 */
export function SignUp (data) {
  return request({
    url: url + 'SignUp',
    method: 'post',
    data
  })
}

/**
 * 注册终端用户【开关电站】
 * @param {*} data
 * @returns
 */
export function SignUpSwitchOrg (data) {
  return request({
    url: url + 'SignUpSwitchOrg',
    method: 'post',
    data
  })
}

/**
 *
 * 分页查询电站列表（管理员和终端用户通用）
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryStations (data) {
  return request({
    url: url + 'QueryStations',
    method: 'post',
    data
  })
}

/**
 *
 * 创建电站
 * @export
 * @param {*} data
 * @return {*}
 */
export function CreateStation (data) {
  return request({
    url: url + 'CreateStation',
    method: 'post',
    data
  })
}

/**
 * 创建开关电站
 * @param {*} data
 * @returns
 */
export function CreateSwitchStation (data) {
  return request({
    url: url + 'CreateSwitchStation',
    method: 'post',
    data
  })
}

/**
 *
 * 删除电站
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeleteStation (data) {
  return request({
    url: url + 'DeleteStation',
    method: 'post',
    data
  })
}

/**
 *
 * 修改电站信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function UpdateStation (data) {
  return request({
    url: url + 'UpdateStation',
    method: 'post',
    data
  })
}

/**
 * 更新电表电站信息
 * @param {*} data
 * @returns
 */
export function UpdateMeterStation (data) {
  return request({
    url: url + 'UpdateMeterStation',
    method: 'post',
    data
  })
}

/**
 * 修改开关电站信息
 * @param {*} data
 * @returns
 */
export function UpdateSwitchStation (data) {
  return request({
    url: url + 'UpdateSwitchStation',
    method: 'post',
    data
  })
}

/**
 * 修改组串电站信息
 * @param {*} data
 * @returns
 */
export function UpdateSeriesStation (data) {
  return request({
    url: url + 'UpdateSeriesStation',
    method: 'post',
    data
  })
}

/**
 * 修改储能电站信息
 * @param {*} data
 * @returns
 */
export function UpdateEnergyStation (data) {
  return request({
    url: url + 'UpdateEnergyStation',
    method: 'post',
    data
  })
}

/**
 * 修改气象电站信息
 * @param {*} data
 * @returns
 */
export function UpdateWeatherStation (data) {
  return request({
    url: url + 'UpdateWeatherStation',
    method: 'post',
    data
  })
}

/**
 *
 * 将采集器从电站解绑，同时将设备从终端用户删除授权（电站 - 实时）
 * @export
 * @param {*} data
 * @return {*}
 */
export function UnbindGateways (data) {
  return request({
    url: url + 'UnbindGateways',
    method: 'post',
    data
  })
}

/**
 *
 * 将采集器绑定到电站（电站 - 实时）
 * @export
 * @param {*} data
 * @return {*}
 */
export function BindGatewayToStation (data) {
  return request({
    url: url + 'BindGatewayToStation',
    method: 'post',
    data
  })
}

/**
 *
 * 获取电站信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetStation (data) {
  return request({
    url: url + 'GetStation',
    method: 'post',
    data
  })
}

/**
 *
 * 分页查询组串电站的实时数据（组串电站 - 实时）
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryClusterStationReal (data) {
  return request({
    url: url + 'QueryClusterStationReal',
    method: 'post',
    data
  })
}

/**
 *
 * 获取历史界面右侧的设备列表，组串储能通用（电站 - 历史）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetInvertersForHistory (data) {
  return request({
    url: url + 'GetInvertersForHistory',
    method: 'post',
    data
  })
}

/**
 *
 * 分页查询储能电站的实时列表（储能电站 - 实时）
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryStationReal (data) {
  return request({
    url: url + 'QueryStationReal',
    method: 'post',
    data
  })
}

/**
 *
 * 获取储能逆变器的详细实时数据（储能电站 - 实时）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetRealDetails (data) {
  return request({
    url: url + 'GetRealDetails',
    method: 'post',
    data
  })
}

/**
 *
 * 组串设置
 * @export
 * @param {*} data
 * @return {*}
 */
export function SetUp (data) {
  return request({
    url: url + 'SetUp',
    method: 'post',
    data
  })
}
/**
 *
 * 删除电站实时数据
 * @export
 * @param {*} data
 * @return {*}
 */
export function DelStationReal (data) {
  return request({
    url: url + 'DelStationReal',
    method: 'post',
    data
  })
}

/**
 *
 * 电站电表绑定
 * @export
 * @param {*} data
 * @return {*}
 */
export function DeviceBind (data) {
  return request({
    url: url + 'DeviceBind',
    method: 'post',
    data
  })
}

/**
 *
 * 创建终端
 * @export
 * @param {*} data
 * @return {*}
 */
export function CreateTerminalForManager (data) {
  return request({
    url: url + 'CreateTerminalForManager',
    method: 'post',
    data
  })
}

/**
 * 创建开关电站终端
 * @param {*} data
 * @returns
 */
export function CreateSwitchTerminalForManager (data) {
  return request({
    url: url + 'CreateSwitchTerminalForManager',
    method: 'post',
    data
  })
}

/**
 *
 * 结算报表预览
 * @export
 * @param {*} data
 * @return {*}
 */
export function StationFeeSettlementPreview (data) {
  return request({
    url: url + 'StationFeeSettlementPreview',
    method: 'post',
    data
  })
}

/**
 *
 * 结算报表导出
 * @export
 * @param {*} data
 * @return {*}
 */
export function StationFeeSettlementExport (data) {
  return request({
    url: url + 'StationFeeSettlementExport',
    method: 'post',
    data
  })
}

/**
 * 骊住电站费用结算预览
 * @param {*} data
 * @returns
 */
export function LizhuStationFeeSettlementPreview (data) {
  return request({
    url: url + 'LizhuStationFeeSettlementPreview',
    method: 'post',
    data
  })
}

/**
 * 骊住电站费用结算导出
 * @param {*} data
 * @returns
 */
export function LizhuStationFeeSettlementExport (data) {
  return request({
    url: url + 'LizhuStationFeeSettlementExport',
    method: 'post',
    data
  })
}

/**
 * 注册时创建账号和电站信息
 * @param {*} data
 * @returns
 */
export function CreateStationByRegister (data) {
  return request({
    url: url + 'CreateStationByRegister',
    method: 'post',
    data
  })
}

/**
 * 终端账号创建电站信息
 * @param {*} data
 * @returns
 */
export function CreateStationByTerminal (data) {
  return request({
    url: url + 'CreateStationByTerminal',
    method: 'post',
    data
  })
}

/**
 * 安装商账号创建终端账号和电站信息
 * @param {*} data
 * @returns
 */
export function CreateStationByInstaller (data) {
  return request({
    url: url + 'CreateStationByInstaller',
    method: 'post',
    data
  })
}
